import { styled, Box as MuiBox, Stack as MuiStack } from "@mui/material";

export const Box = styled(MuiBox)(
  ({ theme }) => `
  &.certificate-button {
    display: flex;
    gap: 2px;
    max-width: 131px;
    align-items: center;
    font-size: 10px;
    border: solid 1px ${theme.palette.unoblue};
    border-radius: 2px;
    color: ${theme.palette.unoblue};
    padding: 3px;
    cursor: pointer;

    svg {
      width: 8px;
      height: 8px;
    }
  }
`
);

export const Stack = styled(MuiStack)`
  .label {
    white-space: nowrap;
  }
`;
